module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-420d19b1","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/App.vue
// module id = 163
// module chunks = 4